import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import { useDispatch } from 'react-redux';
import ColorConstants from '../../../defaults/ColorConstants';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '40%'
  },
  select: {
    color: ColorConstants.GrayAlien,
    backgroundColor: ColorConstants.WhiteAlien,
    '&.MuiSelect-icon': {
      color: ColorConstants.GrayAlien,
    }
  },
  inputLabel: {
    color: ColorConstants.GrayAlien,
    left: -3,
    '&.MuiFormLabel-root.Mui-focused': {
      color: ColorConstants.GrayAlien,
    },
  },
}));

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&:hover $notchedOutline': {
          //border on hover
          borderColor: ColorConstants.BlueAlien,
          border: '1px solid'
        },
        '&$focused $notchedOutline': {
          //border on focus
          borderColor: ColorConstants.BlueAlien,
          border: '2px solid'
        },
      },
    },
    MuiSelect: {
      icon: {
        color: ColorConstants.GrayAlien
      },
      root: {
        padding: 16
      }
    },
    MuiInputLabel: {
      root: {
        fontSize: 14
      }
    }
  },
});

export default function ToFromDateFilter({setMinDate, minDate, setMaxDate, maxDate}) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChangeTo = (value) => {
    dispatch(setMaxDate(value));
  };

  const handleChangeFrom = (value) => {
    dispatch(setMinDate(value));
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
      <FormControl className={classes.formControl}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="From"
            format="MM/dd/yyyy"
            value={minDate!=null ? new Date(minDate) : null}
            onChange={handleChangeFrom}
            renderInput={(params) => <TextField {...params} />}
          />
          </LocalizationProvider>
        </FormControl>
        <FormControl className={classes.formControl}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="To"
            format="MM/dd/yyyy"
            value={maxDate!=null ? new Date(maxDate) : null}
            onChange={handleChangeTo}
            renderInput={(params) => <TextField {...params} />}
          />
          </LocalizationProvider>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}
